import React, { useRef } from 'react'
import PropTypes from 'prop-types'
import { useHistory } from 'react-router'
import { isEmpty } from 'lodash'
import { useSelector } from 'react-redux'

import Modal from 'components/Modal'
import Loader from 'components/Loader'
import { SpySidebar } from 'components/SpySidebar.js'
import Details from 'components/OrderDetails/Sections/Details'
import LineItems from 'components/OrderDetails/Sections/LineItems'
import OrderNotes from 'components/OrderDetails/Sections/OrderNotes'
import PaymentTransactionHistory from 'components/OrderDetails/Sections/PaymentTransactionHistory'
import Identification from 'components/OrderDetails/Sections/Identification'
import OrderStateHistory from 'components/OrderDetails/Sections/OrderStateHistory'
import OrderMutationHistory from 'components/OrderDetails/Sections/OrderMutationHistory'
import OrderStatus from 'components/OrderDetails/Sections/OrderStatus'

import { DISABLE_REFUND_STATES_REASONS } from 'utils/resources'
import { getIsLoadingRefundOrders } from 'store/Orders/selector'
import { getDisableButtonDetailes } from 'utils/Orders/getDisableButtonDetails'

const OrderDetails = ({ order }) => {
  const history = useHistory()

  const { isRefundButtonDisable, disableRefundReason } =
    getDisableButtonDetailes(DISABLE_REFUND_STATES_REASONS, order?.state)

  const sectionRefs = [
    useRef(null),
    useRef(null),
    useRef(null),
    useRef(null),
    useRef(null),
    useRef(null),
    useRef(null),
    useRef(null),
  ]

  const settings = [
    { text: 'Details', ref: sectionRefs[0] },
    { text: 'Line Items', ref: sectionRefs[1] },
    { text: 'Order Notes', ref: sectionRefs[2] },
    { text: 'Payment Transaction History', ref: sectionRefs[3] },
    { text: 'Order State History', ref: sectionRefs[4] },
    { text: 'Mutation History', ref: sectionRefs[5] },
    { text: 'Identification', ref: sectionRefs[6] },
  ]

  const onCloseModal = () => {
    history.push('/orders')
  }

  const onClickSendReceipt = () => {
    history.push(`${window.location.pathname}/send-receipt`)
  }
  const onClickRefund = () => {
    history.push(`${window.location.pathname}/refund`)
  }

  const {
    paymentAuthorizedAt,
    paymentSettledAt,
    paymentVoidedAt,
    paymentRefundedAt,
  } = order
  const isPaymentDateEmpty =
    isEmpty(paymentAuthorizedAt) &&
    isEmpty(paymentSettledAt) &&
    isEmpty(paymentVoidedAt) &&
    isEmpty(paymentRefundedAt)

  const isLoadingRefundOrders = useSelector(getIsLoadingRefundOrders)
  const isLoading = isLoadingRefundOrders || isEmpty(order)

  return (
    <Modal
      title="Order Details"
      onClose={onCloseModal}
      onRequestClose={onCloseModal}
    >
      <div className="modal-body">
        <section
          className={`item-settings -fullHeight order-details ${
            isLoading ? 'loading' : ''
          }`}
        >
          {isLoading ? (
            <Loader />
          ) : (
            <>
              <OrderStatus order={order} />
              <button
                className="order-details__vertical-button"
                onClick={onClickSendReceipt}
              >
                <span className="order-details__vertical-button-label">
                  Send Receipt
                </span>
              </button>
              <button
                className="order-details__vertical-button"
                onClick={onClickRefund}
                disabled={isRefundButtonDisable}
                title={disableRefundReason}
              >
                <span className="order-details__vertical-button-label">
                  Refund
                </span>
              </button>
              <Details
                order={order}
                id={settings[0].text}
                ref={settings[0].ref}
              />
              <LineItems
                order={order}
                id={settings[1].text}
                ref={settings[1].ref}
              />
              <OrderNotes
                order={order}
                id={settings[2].text}
                ref={settings[2].ref}
              />
              {!isPaymentDateEmpty && (
                <PaymentTransactionHistory
                  order={order}
                  id={settings[3].text}
                  ref={settings[3].ref}
                />
              )}
              <OrderStateHistory
                order={order}
                id={settings[4].text}
                ref={settings[4].ref}
              />
              <OrderMutationHistory
                order={order}
                id={settings[5].text}
                ref={settings[5].ref}
              />
              <Identification
                order={order}
                id={settings[3].text}
                ref={settings[3].ref}
              />
            </>
          )}
        </section>
        {!isLoading && <SpySidebar settings={settings} />}
      </div>
    </Modal>
  )
}

OrderDetails.propTypes = {
  order: PropTypes.object,
}

export default OrderDetails
